export default __webpack_public_path__ + "static/media/gow-dan.d847e1c8.jpg";